import {
  Organization,
  OrganizationType,
  Maybe,
  OrganizationRole
} from 'types/schema-generated-types';

export interface Entities {
  DISTRICT: Maybe<Organization>[];
  SCHOOL: Maybe<Organization>[];
}

export const buildOrganizationTypeMap = (organizations: Organization[]): Entities | undefined => {
  if (!organizations) return undefined;

  const mergedOrganizations: Maybe<Organization>[] = [];

  organizations.forEach(organization => {
    const { subOrganizations, ...currentOrg } = organization;
    subOrganizations?.forEach(subOrganization => mergedOrganizations.push(subOrganization));
    mergedOrganizations.push(currentOrg);
  });

  return {
    DISTRICT:
      mergedOrganizations.filter(
        organization => organization?.type === OrganizationType.DISTRICT
      ) || [],
    SCHOOL:
      mergedOrganizations.filter(organization => organization?.type === OrganizationType.SCHOOL) ||
      []
  };
};

export const filterPublicOrgAssociationRoles = (roles: OrganizationRole[] = []) => {
  const filteredRoles = roles.filter(x => x.public === true);
  return filteredRoles;
};
